module.exports = __webpack_public_path__ + "img/illegal_cut_al.b06666d2.svg";